export default class ScrollToLink {
    init() {
        // Au chargement, on vérifie s'il y a une ancre dans l'URL de la page. S'il y en a une, on fait défiler vers cette ancre.
        const currentURL = window.location.href;
        if (currentURL.includes('#')) {
            const link = currentURL.split('#')[1].split('/')[0];

            if (link) {
                this.scrollTo(`#${link}`);
            }
        }

        $('.scroll-to').on('click', (e) => {
            e.preventDefault();
            const link = e.currentTarget.getAttribute('href');
            this.scrollTo(link);
        });
    }

    scrollTo(link) {
        console.log("scrollTo Started");
        const $target = $(link);

        if ($target.length) {
            const headerHeight = $('#sticky-header').outerHeight() + 30;

            $('html, body').animate({
                scrollTop: $target.offset().top - headerHeight + 'px'
            }, 400);
        }
    }
}
